var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 85,
    viewBox: "0 0 88 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42403 69.7295C8.8281 69.3398 8.29091 68.9229 7.81388 68.486C7.23228 67.9517 6.3255 67.9904 5.78974 68.5734C5.25541 69.155 5.29409 70.0618 5.87712 70.5961C6.46302 71.1347 7.12341 71.6476 7.85686 72.1275C8.51868 72.5601 9.40684 72.3739 9.83946 71.7121C10.2721 71.0502 10.0859 70.1621 9.42403 69.7295Z",
    fill: "url(#paint0_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95987 65.3293C4.53441 64.752 4.17485 64.1719 3.87976 63.5917C3.52163 62.8869 2.65782 62.6061 1.95302 62.9643C1.24822 63.3224 0.967452 64.1862 1.32558 64.891C1.68944 65.6044 2.13065 66.3192 2.65352 67.0283C3.12196 67.6643 4.01871 67.8004 4.65618 67.332C5.29221 66.8621 5.4283 65.9654 4.95987 65.3293Z",
    fill: "url(#paint1_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86544 59.4828C2.87976 58.9055 2.96428 58.3454 3.11899 57.8082C3.33673 57.049 2.89695 56.2539 2.13629 56.0362C1.37705 55.8184 0.582009 56.2582 0.364267 57.0189C0.145092 57.7867 0.0218936 58.5875 0.000405849 59.4112C-0.0182169 60.2019 0.60636 60.8595 1.39711 60.8781C2.18786 60.8981 2.84538 60.2736 2.86544 59.4828Z",
    fill: "url(#paint2_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06861 54.6986C5.43677 54.3577 5.84933 54.0425 6.30057 53.7574C6.96956 53.3348 7.17011 52.4496 6.74895 51.782C6.32636 51.113 5.44107 50.9125 4.77208 51.3336C4.16613 51.7161 3.61604 52.1387 3.12182 52.5971C2.54165 53.1343 2.50727 54.0411 3.04447 54.6212C3.58166 55.2014 4.48844 55.2358 5.06861 54.6986Z",
    fill: "url(#paint3_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3973 52.2264C11.1179 52.0931 11.8814 52.0072 12.6865 51.9742C13.4772 51.9399 14.0903 51.2709 14.0574 50.4816C14.0244 49.6922 13.3555 49.0777 12.5647 49.1106C11.6192 49.1508 10.7225 49.2525 9.87587 49.4086C9.09945 49.5533 8.58374 50.3011 8.72843 51.0775C8.87168 51.8553 9.61945 52.3696 10.3973 52.2264Z",
    fill: "url(#paint4_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8637 52.1451C19.0856 52.1595 20.223 52.1165 21.2788 52.0234C22.0667 51.9532 22.6497 51.257 22.5795 50.4691C22.5093 49.6826 21.8131 49.0996 21.0253 49.1698C20.0583 49.2543 19.0169 49.2944 17.8966 49.2801C17.1059 49.2715 16.457 49.9061 16.4484 50.6954C16.4383 51.4862 17.0729 52.1365 17.8637 52.1451Z",
    fill: "url(#paint5_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9858 51.1434C27.404 50.7094 28.6016 50.1536 29.6043 49.5161C30.2704 49.0906 30.4681 48.2053 30.0427 47.5378C29.6186 46.8717 28.7319 46.674 28.0644 47.0994C27.2578 47.6123 26.2909 48.0535 25.1478 48.403C24.3928 48.6351 23.9659 49.4359 24.198 50.1922C24.4286 50.9486 25.2308 51.3741 25.9858 51.1434Z",
    fill: "url(#paint6_linear_11205_9052)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Exp-3.-G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2105 0C55.806 0 56.9406 4.64278 56.9406 8.59509C56.9406 12.5488 54.3735 14.3252 51.2105 14.3252C48.0475 14.3252 45.4805 12.5488 45.4805 8.59509C45.4805 4.64278 46.615 0 51.2105 0Z",
    fill: "url(#paint7_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2114 0C55.8069 0 56.9415 4.64278 56.9415 8.59509C56.9415 12.5488 54.3744 14.3252 51.2114 14.3252C50.9249 14.3252 50.6427 14.3108 50.3662 14.2807C53.1295 13.9856 55.2525 12.1893 55.2525 8.59509C55.2525 4.65711 55.8026 0.0358129 51.2644 0H51.2114Z",
    fill: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2123 60.082C68.2106 60.082 80.5789 63.6117 82.0114 67.9609C83.3723 72.0908 68.2106 75.8397 51.2123 75.8397C34.2141 75.8397 19.0524 72.0908 20.4132 67.9609C21.8458 63.6117 34.2141 60.082 51.2123 60.082Z",
    fill: "url(#paint8_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9524 64.3477C80.1728 65.4292 81.5824 66.6583 82.0107 67.9605C83.3716 72.0904 68.2098 75.8393 51.2116 75.8393C41.6467 75.8393 32.6634 74.6517 26.8789 72.8783C31.5718 73.4126 36.7489 73.7163 42.0808 73.7163C61.9899 73.7163 79.7488 69.4832 78.1544 64.8204C78.0999 64.6614 78.0326 64.5038 77.9524 64.3477Z",
    fill: "#B8CAE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M51.2143 72.2431C55.1701 72.2431 58.3769 69.0363 58.3769 65.0805C58.3769 61.1248 55.1701 57.918 51.2143 57.918C47.2586 57.918 44.0518 61.1248 44.0518 65.0805C44.0518 69.0363 47.2586 72.2431 51.2143 72.2431Z",
    fill: "url(#paint9_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1578 66.3168C44.0876 65.9157 44.0518 65.5031 44.0518 65.0805C44.0518 61.1282 47.2606 57.918 51.2143 57.918C54.1123 57.918 56.6106 59.6427 57.738 62.121C56.433 61.5909 55.0076 61.2987 53.515 61.2987C49.6113 61.2987 46.1719 63.2928 44.1578 66.3168Z",
    fill: "#526B8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.415 67.9624C20.415 67.9624 23.7943 59.0336 26.4803 51.934C28.6262 46.2627 29.7264 40.2504 29.7264 34.188C29.7264 32.3673 29.7264 30.3904 29.7264 28.3677C29.7264 23.0488 31.8393 17.9476 35.6011 14.1858C39.3615 10.4255 44.4627 8.3125 49.7816 8.3125H52.6466C57.9656 8.3125 63.0668 10.4255 66.8271 14.1858C70.5889 17.9476 72.7019 23.0488 72.7019 28.3677V34.3227C72.7019 40.4324 73.8192 46.4919 75.9981 52.2005L82.0132 67.9624C80.5807 63.6133 68.2124 60.0836 51.2141 60.0836C35.2774 60.0836 23.4119 63.1864 20.8104 67.1574L20.415 67.9624Z",
    fill: "url(#paint10_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4449 8.3125C31.1374 16.581 36.2744 32.6051 33.1157 47.2196C32.219 51.3682 30.6532 57.2243 27.6707 63.0733C24.2012 64.2193 21.8146 65.6231 20.8104 67.1574L20.415 67.9624C20.415 67.9624 23.7943 59.0336 26.4803 51.934C28.6262 46.2627 29.7264 40.2504 29.7264 34.188C29.7264 32.3673 29.7264 30.3904 29.7264 28.3677C29.7264 23.0488 31.8393 17.9476 35.6011 14.1858C39.3615 10.4255 44.4627 8.3125 49.7816 8.3125H50.4449Z",
    fill: "#F2F8FD"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M19.6658 77.1045L14.2544 82.5158H19.5512V84.4748H11.8765V82.1255L17.1857 76.8126H11.8174V74.8555H19.6658V77.1045Z",
    fill: "url(#paint11_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M21.7546 84.4012V82.7287L24.6303 79.8512H21.7188V78.2969H26.7719V79.9102L23.8353 82.8469H26.7039V84.4012H21.7546Z",
    fill: "url(#paint12_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M29.0409 84.4012V82.7287L31.9166 79.8512H29.0068V78.2969H34.0582V79.9102L31.1216 82.8469H33.9902V84.4012H29.0409Z",
    fill: "url(#paint13_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M37.1808 84.3987C37.6674 84.3987 38.0618 84.0043 38.0618 83.5177C38.0618 83.0312 37.6674 82.6367 37.1808 82.6367C36.6942 82.6367 36.2998 83.0312 36.2998 83.5177C36.2998 84.0043 36.6942 84.3987 37.1808 84.3987Z",
    fill: "url(#paint14_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M40.9884 84.3987C41.475 84.3987 41.8694 84.0043 41.8694 83.5177C41.8694 83.0312 41.475 82.6367 40.9884 82.6367C40.5019 82.6367 40.1074 83.0312 40.1074 83.5177C40.1074 84.0043 40.5019 84.3987 40.9884 84.3987Z",
    fill: "url(#paint15_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M75.6007 35.6644C82.4472 35.6644 87.9974 30.1142 87.9974 23.2677C87.9974 16.4213 82.4472 10.8711 75.6007 10.8711C68.7543 10.8711 63.2041 16.4213 63.2041 23.2677C63.2041 30.1142 68.7543 35.6644 75.6007 35.6644Z",
    fill: "url(#paint16_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M75.6006 29.6974C76.3315 29.6974 76.9239 29.1049 76.9239 28.3741C76.9239 27.6432 76.3315 27.0508 75.6006 27.0508C74.8698 27.0508 74.2773 27.6432 74.2773 28.3741C74.2773 29.1049 74.8698 29.6974 75.6006 29.6974Z",
    fill: "url(#paint17_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M66.9893 20.9081L68.1621 19.5938C69.5946 20.8741 71.2868 20.9009 72.7533 19.5938L73.9262 20.9081C71.8115 22.7883 69.1165 22.799 66.9893 20.9081Z",
    fill: "url(#paint18_linear_11205_9052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M76.9463 20.9081L78.1192 19.5938C79.5517 20.8741 81.2456 20.9009 82.7104 19.5938L83.8832 20.9081C81.7685 22.7883 79.0736 22.799 76.9463 20.9081Z",
    fill: "url(#paint19_linear_11205_9052)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11205_9052",
    x1: 17.4114,
    y1: 75.4656,
    x2: 17.4114,
    y2: 65.7613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11205_9052",
    x1: 11.6461,
    y1: 71.1175,
    x2: 11.6461,
    y2: 60.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11205_9052",
    x1: 8.17455,
    y1: 64.4555,
    x2: 8.17455,
    y2: 53.2753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11205_9052",
    x1: 13.7511,
    y1: 57.9768,
    x2: 13.7511,
    y2: 48.9225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11205_9052",
    x1: 22.4915,
    y1: 54.5441,
    x2: 22.4915,
    y2: 47.3747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11205_9052",
    x1: 32.2504,
    y1: 54.3268,
    x2: 32.2504,
    y2: 47.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11205_9052",
    x1: 39.9249,
    y1: 54.3691,
    x2: 39.9249,
    y2: 44.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11205_9052",
    x1: 47.2468,
    y1: 0.901052,
    x2: 56.0925,
    y2: 10.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11205_9052",
    x1: 79.8082,
    y1: 74.4631,
    x2: 25.152,
    y2: 60.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11205_9052",
    x1: 57.9672,
    y1: 72.8018,
    x2: 42.529,
    y2: 57.8793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11205_9052",
    x1: 40.4387,
    y1: 10.6217,
    x2: 74.4166,
    y2: 61.5047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11205_9052",
    x1: 9.24883,
    y1: 73.7076,
    x2: 20.8211,
    y2: 77.5413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11205_9052",
    x1: 20.065,
    y1: 77.5685,
    x2: 27.4942,
    y2: 80.0656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_11205_9052",
    x1: 27.3537,
    y1: 77.5685,
    x2: 34.7808,
    y2: 80.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_11205_9052",
    x1: 35.7232,
    y1: 82.4265,
    x2: 38.1983,
    y2: 83.4314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_11205_9052",
    x1: 39.5308,
    y1: 82.4265,
    x2: 42.0059,
    y2: 83.4314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_11205_9052",
    x1: 66.159,
    y1: 17.3286,
    x2: 88.0061,
    y2: 19.7719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_11205_9052",
    x1: 72.7774,
    y1: 25.2101,
    x2: 76.2898,
    y2: 31.1855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_11205_9052",
    x1: 63.0577,
    y1: 17.6961,
    x2: 64.8769,
    y2: 25.5644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_11205_9052",
    x1: 73.0148,
    y1: 17.6961,
    x2: 74.8339,
    y2: 25.5644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526B8F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/noNotifications.09a30c10e1a46cc6bedd70a78c294549.svg";
export { ForwardRef as ReactComponent };